// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ArticleResourceViewModel from '../../../../viewModel/resource/ArticleResourceViewModel';
import ArticleVariantResourceViewModel from '../../../../viewModel/resource/ArticleVariantResourceViewModel';
import ArticleVariantResourceDTO from '../../dto/resource/ArticleVariantResourceDTO';

export default abstract class ArticleVariantResourceModel extends BaseModel<ArticleVariantResourceDTO> {
  /**
  */
  get title() { return this.dto.title; }
  set title(value) { this.dto.title = value; }
  /**
  */
  get article() { return this.getObjectModel(() => this.dto.article, ArticleResourceViewModel)!; }
  set article(value) { this.setObjectModel(() => this.dto.article, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.title = qs.title;
  }
}
